import { ButtonDataType } from "@/shared/types";
import { BlockButton, BlockButtonGroup } from "../directusTypes";
import { getButtonLinkData } from "./getButtonLinkData";

type ButtonLike = BlockButton | Record<string, unknown> | string;

type ButtonGroupInput =
  | BlockButtonGroup
  | { buttons?: ButtonLike[] | null; [key: string]: unknown }
  | string
  | null
  | undefined;

export const getButtonGroupButtons = (
  directusButtonGroup?: ButtonGroupInput
): ButtonDataType[] => {
  if (!directusButtonGroup || typeof directusButtonGroup === "string")
    return [];
  if (!directusButtonGroup.buttons) return [];
  return directusButtonGroup.buttons
    .map((button) => {
      if (typeof button === "string") return;
      return getButtonLinkData(button as BlockButton);
    })
    .filter((item) => !!item);
};
